import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Constants } from "src/app/interfaces/constants";
import { SubSink } from "subsink";
import { LogClass, Logger } from "../../logger";
import { NavigationService } from "../../services";

@Component({
    template: "",
    standalone: false
})
@LogClass({ source: "RootRedirectComponent" })
export class RootRedirectComponent implements OnInit, OnDestroy {
  private subscriptions = new SubSink();
  private logger: Logger;

  constructor(
    private navigate: NavigationService,
    private route: ActivatedRoute
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.sink = this.route.queryParamMap.subscribe((params) => {
      const action = params.get(Constants.queryParams.action);
      if (!action) {
        // default is "circ"
        this.navigate.toCirculationOverview();
        return;
      }

      this.logger.debug("Action detected:" + action);
      //NTH: extract into service? ActionHandlerService?
      if (action.indexOf("redirect=") === 0) {
        const destination = action.substring(9);
        this.logger.debug("Redirecting to :" + destination);
        this.navigate.to([destination], {
          replaceUrl: true,
          queryParams: { action: null },
          queryParamsHandling: "merge"
        });
      } else {
        this.navigate.toError("Unknown action: " + action);
      }
    });
  }
}
